import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import axios from 'axios'
import { API_URL } from '../settings';
import { Grid } from "@mui/material";

const UserDetails = () => {
    const { chosenRange, email } = useParams()
    const createMarkup = (user) => ({__html: user})
    const objConverter = data => Object.keys(data).map(key => ({ key: key, value: data[key] }))
    const [ user, setUser ] = useState()

    useEffect(() => { axios.get(`${API_URL}/public/user-sheet-data/${chosenRange}/${email}`).then(res => setUser(res.data)) }, [])

    if (user) {
        return (
            <Grid key={user.data.userId} container spacing={2} style={{border:"solid 1px #6D9E93", margin:"4rem 0", padding:"5rem"}}>
                <Grid item xl={6} dangerouslySetInnerHTML={ createMarkup(user.html) } style={{margin:"3rem 0"}} />
                <Grid item xl={6} style={{padding:"5rem", wordWrap: "break-word"}}>
                    {objConverter(user.data).map(item => (
                        <h6 style={{fontWeight:"600", margin:"0.5rem 0", color:"#6D9E93"}} key={item.key}>
                            {item.key}: 
                            <span style={{fontWeight:"100", color:"#32322F"}}>{item.value}</span>
                        </h6>
                        ))}
                </Grid>
            </Grid>
        )
    }

    return <h1 style={{textAlign:"center", margin:"5rem", color:"#6D9E93"}}>Loading Data</h1>
}
export default UserDetails;